import React, { useEffect ,useState} from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createHotels, getHotel, resetState, updateHotel } from "../features/luxury/hotel/hotelSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  email: yup.string().required("Email is Required"),
  password: yup.string().required("Password is Required")
});

const AddHotel = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.hotel);
  const { isSuccess, isError, isLoading, createdHotel, hotelName, hotelemail, hotelPassword, updatedHotel } = NewsState;
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState("");
  const type = "Hotel";

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getHotel(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId]);

  useEffect(() => {
    dispatch(resetState());
   
  }, []);

  useEffect(() => {
    if (isSuccess && createdHotel) {
      toast.success("Hotel Added Successfully!");
      dispatch(resetState());
    }
    if (isSuccess && updatedHotel) {
      toast.success("Hotel Updated Successfully!");
      navigate("/Luxury/Hotel-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      
      name: hotelName || "",
      email:hotelemail ||"",
      password:hotelPassword ||""
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (!image ) {
        setImageError("Please select Logo.");
        return;
      } else {
        setImageError("");
      }
      
      const formData = new FormData();
      
      formData.append("name", values.name);
      formData.append("type", type);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("image", image);
      console.log(formData);
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: formData };
        dispatch(updateHotel(data));
        dispatch(resetState());
      } else {
        dispatch(createHotels(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Hotel</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Hotel Name"
              name="name"
              onChng={formik.handleChange("name")}
              onBlr={formik.handleBlur("name")}
              value={formik.values.name}
            />
            <div className="error">{formik.touched.name && formik.errors.name}</div>
          </div>
          <div className="mt-4">
          <CustomInput
            type="text"
            label="Email Address"
           
            name="email"
            value={formik.values.email}
            onChng={formik.handleChange("email")}
            onBlr={formik.handleBlur("email")}
          />
           <div className="error">{formik.touched.email && formik.errors.email}</div>
          </div>
          <div className="mt-4">
          <CustomInput
            type="password"
            label="Password"
            name="password"
            value={formik.values.email}
            onChng={formik.handleChange("password")}
            onBlr={formik.handleBlur("password")}
          />
           <div className="error">{formik.touched.password && formik.errors.password}</div>
          </div>
          <div className="mt-4">
            <label htmlFor="image" className="form-label">
              Select Logo
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                setImage(e.target.files[0]);
                setImageError(""); 
              }}
              className="form-control"
            />
            <div className="error">{imageError}</div>
          </div>

          

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Hotel
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddHotel;